import React, { useState } from 'react';
import { Loader2, Send, CheckCircle2, Trash2, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { suppliersAPI } from '../services/api';

// Admin: auto-generated draft purchase order — adjust quantities, then validate (with or without supplier e-mail) or delete
const DraftPurchaseOrderRow = ({ po, onChanged }) => {
  const [qty, setQty] = useState(() => Object.fromEntries(po.lines.map(l => [l.product_id, l.quantity])));
  const [busy, setBusy] = useState(false);

  const total = po.lines.reduce((n, l) => n + (Number(l.purchase_price) || 0) * (Number(qty[l.product_id]) || 0), 0);

  const validate = async (sendEmail) => {
    setBusy(true);
    try {
      const r = await suppliersAPI.validatePurchaseOrder(po.id, { send_email: sendEmail, quantities: Object.fromEntries(Object.entries(qty).map(([k, v]) => [k, Math.max(0, parseInt(v, 10) || 0)])) });
      toast.success(`Bon ${r.number} ${r.status === 'envoyé' ? 'envoyé au fournisseur' : 'validé'}`);
      onChanged && onChanged();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Validation impossible');
    } finally {
      setBusy(false);
    }
  };

  const remove = async () => {
    if (!window.confirm(`Supprimer le brouillon ${po.number} ?`)) return;
    try {
      await suppliersAPI.deletePurchaseOrder(po.id);
      toast.success('Brouillon supprimé');
      onChanged && onChanged();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Suppression impossible');
    }
  };

  return (
    <div className="mx-4 my-3 border border-orange-200 bg-orange-50/60 rounded-lg" data-testid={`po-draft-${po.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2 px-4 py-2 border-b border-orange-200">
        <div className="flex items-center gap-2 text-sm">
          <Sparkles size={15} className="text-orange-500" />
          <span className="font-semibold text-gray-900">{po.number}</span>
          <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-700" data-testid={`po-status-${po.id}`}>brouillon</span>
          <span className="text-xs text-gray-500">créé le {new Date(po.created_at).toLocaleDateString('fr-FR')} — {po.notes}</span>
        </div>
        <div className="flex items-center gap-1">
          <button type="button" data-testid={`po-validate-send-${po.id}`} onClick={() => validate(true)} disabled={busy} className="inline-flex items-center gap-1 text-xs font-medium text-white bg-[#1e3a5f] hover:bg-[#274b7a] rounded px-2.5 py-1.5 disabled:opacity-50">{busy ? <Loader2 size={13} className="animate-spin" /> : <Send size={13} />} Valider & envoyer</button>
          <button type="button" data-testid={`po-validate-${po.id}`} onClick={() => validate(false)} disabled={busy} className="inline-flex items-center gap-1 text-xs font-medium text-[#1e3a5f] border border-[#1e3a5f]/30 hover:bg-white rounded px-2.5 py-1.5 disabled:opacity-50"><CheckCircle2 size={13} /> Valider sans e-mail</button>
          <button type="button" data-testid={`po-delete-${po.id}`} onClick={remove} disabled={busy} title="Supprimer le brouillon" className="p-1.5 text-red-500 hover:bg-red-50 rounded disabled:opacity-50"><Trash2 size={15} /></button>
        </div>
      </div>
      <div className="overflow-x-auto"><table className="w-full text-sm">
        <tbody className="divide-y divide-orange-100">
          {po.lines.map(l => (
            <tr key={l.product_id} data-testid={`po-draft-line-${po.id}-${l.product_id}`}>
              <td className="px-4 py-1.5"><span className="font-medium text-gray-900">{l.name}</span><span className="block text-xs text-gray-500">{l.brand} · Réf. {l.ref || '—'}{l.supplier_ref ? ` · Réf. fourn. ${l.supplier_ref}` : ''}</span></td>
              <td className="px-4 py-1.5 text-right text-gray-600 whitespace-nowrap">{l.purchase_price != null ? `${Number(l.purchase_price).toFixed(2)} € HT` : '—'}</td>
              <td className="px-4 py-1.5 text-right whitespace-nowrap">
                <input type="number" min="0" data-testid={`po-draft-qty-${po.id}-${l.product_id}`} value={qty[l.product_id]} onChange={(e) => setQty(q => ({ ...q, [l.product_id]: e.target.value }))} className="w-20 border border-gray-300 rounded px-2 py-1 text-right text-sm focus:outline-none focus:ring-2 focus:ring-orange-400" />
                <span className="ml-1 text-xs text-gray-500">u.</span>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot><tr><td colSpan={3} className="px-4 py-1.5 text-right text-xs text-gray-600">Total estimé : <span className="font-semibold text-gray-900" data-testid={`po-draft-total-${po.id}`}>{total.toFixed(2)} € HT</span> · quantité 0 = ligne retirée</td></tr></tfoot>
      </table></div>
    </div>
  );
};

export default DraftPurchaseOrderRow;
